import { Suspense } from "react";
import AlertProvider from "./components/AlertProvider/AlertProvider";
import AuthProvider from "./components/AuthProvider/AuthProvider";
import CalendarProvider from "./components/Calendar/CalendarProvider/CalendarProvider";
import Home from "./pages/Home";

function App() {
  return (
    <Suspense>
          <AuthProvider>
              <AlertProvider>
                  <Home />
              </AlertProvider>       
      </AuthProvider>
    </Suspense>
  );
}

export default App;
